module.exports = __webpack_public_path__ + "images/vic-state-gov-logo.svg";